
<template>
  <div>
    <ProofDetailModal v-if="showProofModal" :proof-id="selectedProofId" :amount="selectedAmount" @proof-modal-close="closeModal()" />
    <v-card class="table-card" elevation="17">
      <v-row align="center" justify="center" class="mb-0">
        <v-col cols="2" align="center" justify="center">
          <a class="caption blue--text text--darken-3" @click="loadPreviousMonth"> {{ prevMonth | monthYear }}</a>
        </v-col>
        <v-col cols="8" align="center" justify="center">
          <h1 class="mt-1 ml-1 w-full font-weight-light text-center">{{ currentMonth | monthYear }}</h1>
        </v-col>
        <v-col cols="2" align="center" justify="center">
          <a v-if="nextMonth" class="caption blue--text text--darken-3" @click="loadNextMonth"> {{ nextMonth | monthYear }}</a>
        </v-col>
      </v-row>
      <v-row align="center" justify="center">
        <v-col cols="2" class="pa-3" align="center" justify="center">
          <span class="w-full caption font-weight-bold"> Activity </span>
        </v-col>
        <v-col cols="6" align="center" justify="center">
          <span class="w-full caption font-weight-bold"> Offer </span>
        </v-col>
        <v-col cols="2" align="center" justify="center"> <span class="w-full caption font-weight-bold"> Value </span> </v-col>
        <hr />
      </v-row>
      <v-row v-if="!dashboardData || dashboardData.length === 0">
        <v-col cols="12" class="pa-3" align="center" justify="center"> <h1>No Data</h1> </v-col>
      </v-row>
      <v-row v-for="row in dashboardData" v-else :key="row.id" class="mb-2" align="center" justify="center" @click="openModal(row.detail_id, row.amount)">
        <v-col cols="3" class="pa-3" align="center" justify="center">
          <div v-if="row.img_url">
            <v-img :src="row.img_url" width="120" height="120" class="rounded-xl" />
          </div>
          <div v-else>
            <v-icon> {{ iconFromType(row.type) }}</v-icon>
          </div>
        </v-col>
        <v-col cols="4" align="left" justify="center">
          <span class="caption blue--text">{{ row.activity_date | shorterDate }}</span>
          <br />
          <span class="offer-summary">
            {{ row.offer_summary }}
          </span>
          <span v-if="row.proof_type" class="proof-type"> {{ row.proof_type | prettyProofType }} </span>
        </v-col>
        <v-col cols="3" align="center" justify="center">
          <span v-if="!row.amount" class="text-body-2 font-weight-light">--</span>
          <span v-else :class="['text-h4', 'font-weight-medium', colorFromType(row.type)].join(' ')">${{ row.amount }}</span>
          <br />
          <span :class="['caption', 'font-weight-medium', colorFromType(row.type)].join(' ')">{{ actionName(row.type, row.activity_date) }}</span>
        </v-col>
        <hr />
      </v-row>
    </v-card>
  </div>
</template>

<script>
import Vue from 'vue'
import { ApiService } from '@/services/index'
import ProofDetailModal from '@/components/Dashboard/ProofDetailModal'
import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc'
dayjs.extend(utc)

export default Vue.extend({
  name: 'ActivityLogTable',

  components: { ProofDetailModal },
  data: () => ({
    dashboardData: {},
    loading: false,
    showProofModal: false,
    selectedProofId: null,
    selectedAmount: null,
    currentMonth: dayjs(),
  }),
  computed: {
    prevMonth() {
      return dayjs(this.currentMonth).subtract(1, 'month')
    },
    nextMonth() {
      const nextMonth = dayjs(this.currentMonth).add(1, 'month')
      if (nextMonth.isAfter(dayjs().startOf('month'))) return null
      return nextMonth
    },
  },
  mounted() {
    this.loadData()
  },
  methods: {
    openModal(proofId, amount) {
      if (!proofId) return
      this.selectedProofId = proofId
      this.selectedAmount = amount
      this.showProofModal = true
    },
    closeModal() {
      this.selectedProofId = null
      this.selectedAmount = null
      this.showProofModal = false
    },
    loadPreviousMonth() {
      this.currentMonth = dayjs(this.currentMonth).subtract(1, 'month')
      this.loadData()
    },
    loadNextMonth() {
      this.currentMonth = dayjs(this.currentMonth).add(1, 'month')
      this.loadData()
    },
    loadData() {
      this.loading = true
      ApiService.get(`dashboard/activity/${this.currentMonth.toISOString()}`).then((response) => {
        this.dashboardData = response.data
        if (this.dashboardData && this.dashboardData.length > 0) {
          this.currentMonth = dayjs(
            response.data.reduce((prev, current) => (prev.activity_date < current.activity_date ? prev.activity_date : current.activity_date))
          )
            .utc()
            .startOf('month')
        }
        this.loading = false
      })
    },
    iconFromType(type) {
      switch (type) {
        case 'post':
          return 'mdi-account-arrow-up'

        case 'redeem':
          return 'mdi-account-cash'

        case 'review':
          return 'mdi-star-check'

        case 'offer_starts':
          return 'mdi-play'

        case 'offer_end':
          return 'mdi-alert-octagon'

        default:
          return ''
          break
      }
    },
    actionName(type, date) {
      switch (type) {
        case 'offer_starts':
          return 'STARTED'

        case 'offer_end':
          return new Date(date) > new Date() ? 'STOPPING' : 'STOPPED'

        default:
          return type.replace(/\_/g, ' ').toUpperCase()
          break
      }
    },
    colorFromType(type) {
      switch (type) {
        case 'post':
          return 'post-color'

        case 'redeem':
          return 'ticket-color'

        case 'review':
          return 'review-color'

        case 'offer_end':
          return 'red--text'

        case 'offer_starts':
          return 'green--text'

        default:
          return ''
          break
      }
    },
  },
})
</script>

<style lang="scss" scoped>
.table-card {
  cursor: pointer;
  border-radius: 25px;
}

hr {
  overflow: visible;
  border: none;
  background-color: lightgray;
  height: 1px;
  display: block;
  width: 85%;
}

.offer-summary {
  font-family: arial, helvetica, sans-serif;
  font-size: 12px;
  line-height: 12pt;
  font-weight: 900;
  color: black;
}

.proof-type {
  font-family: arial, helvetica, sans-serif;
  font-size: 8px;
  line-height: 12pt;
  font-weight: 500;
  color: grey;
  margin-top: 0px;
  display: block;
}

.review-color {
  color: #98e3f8 !important;
}

.post-color {
  color: #1f487e !important;
}

.ticket-color {
  color: #376996 !important;
}
</style>
